export const theme = {
    colors: {
        default: 'white',
        charcoal: '#424242',
        transparent: "transparent",
        single_polygon_color: 'orange',
        garden_polygon_color: '#001308',
        garden_polygon_color_2: '#00D100',
        hover_color: 'silver',
        selected_color: '#424242',
        main_slope_color: 'red',
        directions: {
            north: 'yellow',
            northeast: 'blue',
            northwest: 'lightgreen',
            west: 'purple',
            south: 'peru',
            southeast: 'khaki',
            southwest: 'pink',
            east: 'cyan',
        },
    },
    fonts: {
        default: 'sans-serif',
        custom: 'Kohinoor',
        main_slope_color: 'red',
    },
};
